export const company = {
  mainContactInfo: {
    header: 'Main Contact Info',
    cityState: '%city%, %state%',
  },
  billingContactInfo: {
    header: 'Billing Contact Info',
  },
  badges: {
    header: 'Badges',
  },
  table: {
    title: 'Users',
    headers: {
      requestorName: 'FULL NAME',
      email: 'EMAIL',
      phone: 'PHONE',
      userLevel: 'USER LEVEL',
      lastLogin: 'LAST LOGIN',
    },
    role: {
      read_only: 'Read only',
      manager: 'Manager',
      admin: 'Admin'
    }
  },
  bulkDeleteModal: {
    header: 'Delete Users',
    content: 'Are you sure you want to delete users?',
    warning: 'This action cannot be undone'
  },
  deleteRequestorConfirmation: {
    header: 'Delete User',
    content: 'Are you sure you want to delete this user?',
    warning: 'This action cannot be undone'
  },
  buttons: {
    export: 'Export',
    import: 'Import',
    newRequestor: 'New User',
    bulkDelete: 'Delete Selected',
  },
  uploadModal: {
    title: 'Import Users',
    toasts: {
      success: '%goodRecords% records were imported successfully (%added% added, %updated% updated)',
      noGoodRecords: 'No records could be imported successfully'
    }
  },
  messages: {
    success: 'Company settings have been updated'
  }
};
